import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import {
  ADMIN_WEB_PAGES_URLS,
  AppointmentStatuses
} from '@appgen-health-crm/data';
import {
  DrawerType,
  IAppointment,
  ILead,
  ILookup,
  ISchedule,
  IService
} from '@appgen-health-crm/api-interfaces';
import { AppointmentFacade } from '../../+store/appointment/appointment.facade';
import { CustomerFacade } from '../../+store/customer/customer.facade';
import { CommonModule } from '@angular/common';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule, NzDrawerRef } from 'ng-zorro-antd/drawer';
import { AuthFacade } from '../../+store/auth/auth.facade';
import { takeWhile } from 'rxjs';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzTagModule } from 'ng-zorro-antd/tag';
import {
  isAppointmentActive,
  isAppointmentCloseToStart,
  isProvider
} from '@care-portals/shared';
import { LookupComponent } from '@care-portals/ui';
import { parseISO, subMinutes, isAfter } from 'date-fns';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Clipboard } from '@angular/cdk/clipboard';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { DrawerStateFacade } from '../../+store/drawer-state/drawer-state.facade';
import { OverlayService } from '../../services/overlay/overlay.service';
import {
  getOrgAwareMenuQueryParams,
  withOrgNavigationExtras
} from '../../+store/app/layout-org.util';

@Component({
  selector: 'appgen-health-crm-appointment-details',
  templateUrl: './appointment-details.component.html',
  styleUrls: ['./appointment-details.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzDrawerModule,
    NzPageHeaderModule,
    NzSpinModule,
    NzButtonModule,
    NzDescriptionsModule,
    NzDatePickerModule,
    NzFormModule,
    NzSelectModule,
    NzDividerModule,
    NzPageHeaderModule,
    NzBreadCrumbModule,
    NzTagModule,
    LookupComponent,
    NzPopconfirmModule,
    RouterLink
  ]
})
export class AppointmentDetailsComponent implements OnInit, OnDestroy {
  isActive = true;

  @Input()
  appointment: IAppointment;

  getOrgAwareMenuQueryParams = getOrgAwareMenuQueryParams;
  edit = false;
  appointmentStatuses = AppointmentStatuses;
  loading$ = this.facade.loading$;
  editFG: FormGroup = this.fb.group({
    status: [],
    service: [],
    reservation: []
  });
  schedulesLookups: ILookup[] = [];
  adminRole: string;
  constructor(
    private readonly router: Router,
    private readonly facade: AppointmentFacade,
    private readonly fb: FormBuilder,
    private readonly customerFacade: CustomerFacade,
    private readonly nzDrawerRef: NzDrawerRef<AppointmentDetailsComponent>,
    private readonly auth: AuthFacade,
    private readonly clipboard: Clipboard,
    private readonly notificationService: NzNotificationService,
    private readonly drawerFacade: DrawerStateFacade,
    private readonly overlayService: OverlayService
  ) {
    this.isActive = true;
  }

  ngOnInit(): void {
    this.auth.role$.pipe(takeWhile(() => this.isActive)).subscribe(role => {
      this.adminRole = role;
    });
    // this.appointment$
    //   .pipe(takeWhile(() => this.active))
    //   .subscribe(appointment => {
    //     console.log('appointment$ observed >>', appointment);
    //     this.appointment = appointment;
    //     this.editFG.patchValue({
    //       status: appointment?.status,
    //       service: (appointment?.service as IService)?._id,
    //       reservation: appointment?.reservation,
    //       schedule: appointment?.schedule
    //     });
    //     this.edit = false;
    //   });
    this.appointment = { ...this.appointment };
    this.editFG.patchValue({
      status: this.appointment?.status,
      service: (this.appointment?.service as IService)?._id,
      reservation: this.appointment?.reservation
    });
  }

  ngOnDestroy() {
    this.isActive = false;
    // this.facade.cleanActiveAppointment();
  }

  get appointmentService() {
    return this.appointment?.service as IService;
  }

  get appointmentLead() {
    return this.appointment?.relatedToLead as ILead;
  }

  get appointmentSchedule() {
    return this.appointment?.schedule as ISchedule;
    // return this.schedulesLookups.find(x => x._id == this.appointment?.schedule)
    //   ?.label;
  }

  get isProvider(): boolean {
    return isProvider(this.adminRole);
  }

  startEdit() {
    this.edit = true;
  }

  cancelEdit() {
    this.edit = false;
  }

  save() {
    for (const i in this.editFG.controls) {
      this.editFG.controls[i].markAsDirty();
      this.editFG.controls[i].updateValueAndValidity();
    }

    if (this.editFG.invalid) {
      console.error('invalid FG', this.editFG.errors);
      return;
    }

    this.facade.updateAppointment(this.appointment?._id, {
      ...this.editFG.value
    });
    this.appointment.status = this.editFG.value.status;
    this.appointment.service = this.editFG.value.service;
    this.edit = false;
  }

  goBack() {
    history.back();
  }

  // showAssignProvider() {
  //   this.facade.showAssignProvider(this.appointment);
  // }

  openEmr() {
    // if (!this.appointment.emrId) return;
    // this.facade.openEmr(this.appointment.emrId);
  }

  openLead() {
    this.customerFacade.openCustomer(this.appointmentLead._id);
    this.closeDrawer();
  }

  closeDrawer() {
    this.nzDrawerRef.close();
  }

  compareWith(scheduleId: string, lookup: ILookup) {
    if (!scheduleId || !lookup) return false;
    return scheduleId === lookup._id;
  }

  getKeys(o) {
    return Object.keys(o);
  }

  // TODO make this a pipe to break camel casing keys
  displayKey(k) {
    return k.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  openSession(moveToInProgress?: boolean) {
    if (this.overlayService.isOpen('Session')) {
      alert('Session is in progress, close current session to start new one');
      return;
    }

    this.nzDrawerRef?.close();
    this.router.navigate(
      [
        ADMIN_WEB_PAGES_URLS.session.single.replace(':id', this.appointment._id)
      ],
      withOrgNavigationExtras({
        queryParams: { start: moveToInProgress ? 'true' : undefined }
      })
    );
  }

  get showSessionBtn() {
    return (
      !this.edit &&
      this.isProvider &&
      isAppointmentCloseToStart(this.appointment.reservation) &&
      isAppointmentActive(this.appointment)
    );
  }

  copyToClipboard(link) {
    this.clipboard.copy(link);
    this.notificationService.success('Link Copy to Clipboard', '');
  }

  openCreatePatientDrawer() {
    this.drawerFacade.openDrawer({
      name: DrawerType.CREATE_PATIENT,
      props: { lead: this.appointmentLead }
    });
  }
}
